import api from ".";
import { GENERATE_UNPRB_RESULT } from "./endpoints";

const generateResult = async (data, callback) => {
  api.post(GENERATE_UNPRB_RESULT, data).then((resp) => callback(resp.data.data));
};

export { generateResult };
